const config = {
  reports_progress_statuses() {
    return { ui: ['filter', 'export'] };
  },
  reports_progress_milestone() {
    return { ui: ['yearSwitch', 'filter', 'export'] };
  },
  reports_progress_schedule() {
    return { ui: ['calculationSelection', 'filter', 'export'] };
  },
  reports_progress_portfolio() {
    return { ui: ['filter', 'export'] };
  },
  reports_progress_month() {
    return { ui: ['reportModeSelection', 'range', 'calculationSelection', 'filter', 'export'] };
  },
  reports_budget_project(mode) {
    let tools = ['grouping', 'expandCollapse', 'reportModeSelection', 'range', 'calculationSelection', 'filter', 'export'];

    if (mode === 'graphic') {
      tools = tools.filter(name => !['grouping', 'expandCollapse'].includes(name));
    }

    return { ui: tools };
  },
  reports_budget_month() {
    return { ui: ['reportModeSelection', 'range', 'calculationSelection', 'filter', 'export'] };
  },
  reports_budget_resource() {
    return { ui: ['grouping', 'expandCollapse', 'range', 'calculationSelection', 'filter', 'export'] };
  },
  reports_time_project(mode) {
    let tools = ['grouping', 'expandCollapse', 'reportModeSelection', 'range', 'calculationSelection', 'filter', 'export'];

    if (mode === 'graphic') {
      tools = tools.filter(name => !['grouping', 'expandCollapse'].includes(name));
    }

    return { ui: tools };
  },
  reports_time_month() {
    return { ui: ['reportModeSelection', 'range', 'calculationSelection', 'filter', 'export'] };
  },
  reports_time_timeloglist() {
    return { ui: ['expandCollapse', 'grouping', 'range', 'filter', 'export'] };
  },
  reports_time_resource() {
    return { ui: ['grouping', 'expandCollapse', 'range', 'calculationSelection', 'filter', 'export'] };
  },
};

export default {
  getConfig(routerPath, mode) {
    if (routerPath in config) {
      return config[routerPath](mode);
    }

    return {};
  },
};
